/**
 * Histórico de monitoreo: GET /b/api/historico/monitoreo.
 * Una sola respuesta trae el rango observado, el estado del sitio y el de las cámaras por sucursal.
 * Todas las duraciones llegan en segundos y las fechas en ISO 8601 con offset de Bogotá.
 */

export interface AvailabilityHistoryFilters {
  // Ojo: el back exige DD/MM/YYYY, igual que el resto del proyecto. Con ISO responde 400
  fecha_inicial?: string;  // DD/MM/YYYY
  fecha_final?: string;    // DD/MM/YYYY, inclusiva
  sucursal?: number;       // Obligatoria: sin ella el endpoint responde 400
}

export interface AvailabilityRange {
  desde:           string;
  desde_efectivo:  string;  // El mayor entre 'desde' y el inicio real del monitoreo
  hasta:           string;  // Exclusiva: el día siguiente a fecha_final a las 00:00
  hasta_efectivo:  string;  // El menor entre 'hasta' y el momento actual
  segundos:        number;  // Tiempo observado, es el 100% de los porcentajes
  zona_horaria:    string;
}

export interface WebsiteIncident {
  inicio:       string;
  fin:          string | null;   // null mientras la caída sigue en curso
  duracion_seg: number;
  en_curso:     boolean;
  http_code:    number | null;
  error:        string | null;
}

export interface WebsiteHistory {
  url:          string;
  downtime_seg: number;
  uptime_pct:   number | null;  // null si el rango no tiene tiempo observable
  incidentes:   WebsiteIncident[];
}

export interface CameraIncident {
  inicio:       string;
  fin:          string | null;
  duracion_seg: number;
  en_curso:     boolean;
}

export interface CameraHistory {
  cameraId:    number;
  cameraName:  string;
  offline_seg: number;           // No incluye el monitoreo inactivo de la sucursal
  uptime_pct:  number | null;    // null si no hubo tiempo monitoreado en el rango
  incidentes:  CameraIncident[];
}

export interface BranchInactivity {
  inicio:       string;
  fin:          string | null;
  duracion_seg: number;
}

export interface BranchHistory {
  branchId:     number;
  branchName:   string;
  inactivo_seg: number;          // Tiempo sin monitoreo: no es lo mismo que cámara caída
  inactividad:  BranchInactivity[];
  camaras:      CameraHistory[];
}

export interface ResponseMonitoringHistory {
  rango:      AvailabilityRange;
  website:    WebsiteHistory;
  sucursales: BranchHistory[];
}
